module.exports = __webpack_public_path__ + "static/img/empty-basket.ac7f0f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty-basket.svg
// module id = Mtj8
// module chunks = 1